
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{ planTripInfo.Titulo_Pagina }}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0">
      <div class="row">
        <div [ngClass]="isLandscape ? 'video-centered' : 'video-fullwidth'">
          <iframe *ngIf="youtubeEmbedUrl" title="YoutubeVideo"
            [src]="youtubeEmbedUrl"
            style="width: 100%; height: 500px;"
            frameborder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
        </iframe>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <iframe src="https://transportes.cimtamegaesousa.pt/InfoPublico/Pages/Publico.aspx" width="100%" height="700px" title="Planeador de viagens - CIM Tâmega e Sousa" loading="lazy" style="border:2px solid #373737;">
            O seu navegador não suporta iframes. Pode aceder ao conteúdo diretamente em:
            <a href="https://transportes.cimtamegaesousa.pt/InfoPublico/Pages/Publico.aspx" target="_blank">Planeador de viagens</a>
          </iframe>
        </div>
      </div>
    </div>
  </section>
</main>

